var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 19,
    viewBox: "0 0 32 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.0259 1H3.09978C1.3949 1 0 2.34078 0 3.97952V14.0205C0 15.6592 1.3949 17 3.09978 17H16.0259C17.7308 17 19.1257 15.6592 19.1257 14.0205V3.97952C19.1257 2.31099 17.7308 1 16.0259 1Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 1",
    d: "M16 11.2321C14.6667 10.4623 14.6667 8.53775 16 7.76795L24.25 3.00481C25.5833 2.23501 27.25 3.19726 27.25 4.73686L27.25 14.2631C27.25 15.8027 25.5833 16.765 24.25 15.9952L16 11.2321Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.c1e6932e570d7b4828bf81a279ed9fa4.svg";
export { ForwardRef as ReactComponent };